 /**
 * This manager handles retrieving and caching the user's login properties.
 *
 *
 * This manager is special in that it is probably one of the very first things that must be loaded.
 * Things like feature rights can't be determined until this manager is ready
 *
 *
 */
 import window from "common/objects/window";
 import userOperations from "common/datasources/user/userOperations";

 const LoginProps = kendo.Observable.extend({
    get: function() {
        return window.loginProperties || {};
    },

    reload() {
        return userOperations.getLoginProps().done(props => {
            window.loginProperties = props;
            this.trigger("reload");
        });
    }
})
export default new LoginProps();
